import NextLink from 'next/link';
import { Box, Heading, Link, Text, VStack } from '@chakra-ui/react';
import dayjs from 'dayjs';
import React from 'react';
import Avatar from './AuthorAvatar';
import CoverImage from './CoverImage';
import type { Post } from '../../libs/sanity.queries';

export default function PostPreview({ title, coverImage, date, excerpt, author, slug }: Omit<Post, '_id'>) {
  return (
    <VStack spacing={6} alignItems='start'>
      <CoverImage slug={slug} title={title} image={coverImage} />

      <Box>
        <Link as={NextLink} href={`/posts/${slug}`} mb={4}>
          <Heading as='h3' size='xs' fontSize='xl' fontWeight='bold'>
            {title}
          </Heading>
        </Link>
        {date && (
          <Text color='bg-default-inverted' opacity={0.8}>
            {dayjs(date).format('D MMMM, YYYY')}
          </Text>
        )}
      </Box>

      {excerpt && (
        <Text color='bg-default-inverted' fontSize='lg'>
          {excerpt}
        </Text>
      )}

      {author && <Avatar name={author.name} image={author.image} />}
    </VStack>
  );
}
